// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"331":"5bbc3579","538":"6b28481a","674":"ec849dc5","983":"8e5c6e87"}[chunkId] + ".js";
};